import { useState } from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
// import { parsePhoneNumberFromString, PhoneNumber } from 'libphonenumber-js';

import { URL_CLIENT_VIEW } from 'lib/router/url';
import { Button } from 'modules/core/components/buttons';
import Modal from 'react-bootstrap/Modal';
import { CLIENT_STATUS_ACTIVE } from 'modules/clients/store/constants';
import ClientForm from 'modules/clients/components/ClientForm';
import { FormPage } from '../../core/containers';
import { PhoneInput } from '../../core/components/forms';
import * as actions from '../store/actions';
import { useComponentDidUpdate } from '../../core/hooks';
import Form from '../../core/components/forms/Form';
import SubmitButton from '../../core/components/forms/SubmitButton';
import { clientSearchValidationSchema } from '../validation';
import Can from '../../permissions/abilities/Can';
import { getPhoneParsed } from 'lib/functions';

interface ClientSearchByPhoneProps {
  data?: any;
  findClientByPhone?(...args: unknown[]): unknown;
  lookupError?: any;
}

const ClientSearchByPhone = (props: ClientSearchByPhoneProps) => {
  const {
    lookupError,
    data,
    findClientByPhone,
  } = props;

  const [isLoading, setLoading] = useState(false);
  const [addClientMode, setAddClientMode] = useState(false);
  const [phone, setPhone] = useState(null);
  const navigate = useNavigate();

  /* const getPhoneParsed = (values):PhoneNumber => {
    if (!values?.phoneMobile) return undefined;
    // eslint-disable-next-line no-useless-escape
    const bPhone = values?.phoneMobile.replace(/[^\d\+]/g, '');
    return parsePhoneNumberFromString(bPhone.includes('+7') ? bPhone : `+7${ bPhone }`);
  }; */

  const isCorrectPhone = (values):boolean => {
    if (!values?.phoneMobile) return false;
     
    const phoneParsed = getPhoneParsed(values);
    return phoneParsed?.isValid() ?? false;
  };

  const isPhoneBegin9 = (values):boolean => {
    if (!values?.phoneMobile) return false;
     
    const phoneParsed = getPhoneParsed(values);
    const valid: boolean = phoneParsed?.isValid() ?? false;
    return valid && ((phoneParsed?.nationalNumber[0] ?? '') === '9');
  };

  const handleSearch = async (values, form) => {
    const { phoneMobile } = values;

    if (!phoneMobile) {
      return;
    }
    const phoneParsed = getPhoneParsed(values);
    if (!phoneParsed.isValid()) {
      setPhone(undefined);
      return;
    }
    setPhone(phoneParsed.number);

    setLoading(true);
    try {
      // Далее 2 строчки кода - большой костыль
      // т.к. компонент PhoneInput в некоторых случая глючит и возвращает неформатированный номер телефона.
      // Пример: Вбиваешь номер телефона, ставишь курсов в начало и нажимаешь Del, и маска ломается.
      // Пока не пофиксил проблему в компоненте, пришлось временно костыль поставить.
      const phoneMobileExt = phoneMobile.includes('+7') ? phoneMobile : `+7${ phoneMobile }`;
      await findClientByPhone(phoneMobileExt.replace('%20', '').replace(/[/(/)/-]/g, '').replace(' ', ''));
      form.resetForm();
    } finally {
      form.setSubmitting(false);
    }
    setLoading(false);
  };

  useComponentDidUpdate(() => {
    if (!isEmpty(data)) {
      navigate(`${ URL_CLIENT_VIEW }/${ data?.id }`);
    }
  }, [data]);

  return (
    <FormPage
      header='Поиск клиента'
      showSubmitButton={ false }
    >
      <>
        <Form
          loading={ isLoading }
          validationSchema={ clientSearchValidationSchema }
          initialValues={ { phoneMobile: '' } }
          error={ lookupError }
          disableSubmitButton={ false }
          onSubmit={ handleSearch }
        >
          { ({ handleSubmit, values }) => {
            return (
              <>
                <Row>
                  <Col lg={ 10 }>
                    <PhoneInput
                      name='phoneMobile'
                      placeholder='Мобильный'
                      onKeyUp={ (e) => {
                        if (e.key === 'Enter') handleSubmit();
                      } }
                    />
                  </Col>
                  <Col lg={ 2 }>
                    <SubmitButton
                      text='Найти'
                      disabled={ !isCorrectPhone(values) }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={ 10 }>
                    <Row>
                      <Col lg={ { span: 4, offset: 4 } }>
                        <h5>{ lookupError?.message }</h5>
                      </Col>
                    </Row>
                  </Col>
                  <Col lg={ 2 }>
                    { lookupError?.message
              && (
                <Can do='permissionInsert' on='order.client'>
                  <Button
                    text='Добавить'
                    variant='primary'
                    onClick={ () => {
                      setAddClientMode(true);
                    } }
                    icon='plus'
                    disabled={ !isCorrectPhone(values) || !isPhoneBegin9(values) }
                  />
                </Can>
              ) }
                  </Col>
                </Row>

              </>
            );
          } }
        </Form>
        { (!!addClientMode)
          && (
            <Modal
              show={ true }
              // backdrop='static'
              size='lg'
              onHide={ () => setAddClientMode(false) }
            >
              <Modal.Header>
                <Modal.Title id='modal-client-new'>
                    Ввод нового клиента
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <ClientForm
                  initialValues={ { statusRefValueId: CLIENT_STATUS_ACTIVE, phoneNumber: phone } }
                  onReset={ () => setAddClientMode(false) }
                  onSubmit={ () => setAddClientMode(false) }
                />
              </Modal.Body>
            </Modal>
          ) }
      </>
    </FormPage>
  );
};

const mapStateToProps = (state) => ({
  data: state.clients?.item,
  lookupError: state.clients?.error,
});

const mapDispatchToProps = (dispatch) => ({
  findClientByPhone: (payload) => dispatch(actions.findClientByPhone(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientSearchByPhone);
